<template>
  <b-modal id="save-configuration" title="Confirm configuration" size="lg" centered>
    <p v-if="!(loggedUser && loggedUser.email)">We well send you a email with the link to access this configuration.</p>
    <p v-else>Testo B2B dealer di conferma configurazione DA CREARE</p>
    <div
      class="form-group"
      v-if="!(loggedUser && loggedUser.email)"
    >
      <label for="email-save-input">Your email:</label>
      <input class="form-control" type="email" v-model="loginEmailInput" name="email-save-input" id="email-save-input" />
    </div>

    <div v-if="!(loggedUser && loggedUser.email)" class="form-group">
      <label for="delaer-input">Dealer:</label>
      <select class="form-control" v-model="selectedDealerInput" name="dealer-input" id="delaer-input">
        <option v-for="option in dealers" v-bind:value="option.id" v-bind:key="option.id">
          {{ option.name }}
        </option>
      </select>
    </div>
    <div v-else class="form-group">
      <label for="customer-reference-label">Customer Reference Label:</label>
      <input
        class="form-control"
        type="text"
        id="customer-reference-label"
        style="border: 1px solid black !important;"
        v-model="customerReferenceLabelInput"
        name="customer-reference-label"
      />
    </div>

    <template #modal-footer>
      <div class="w-100">
        <span v-if="!confirmDisabled">Please wait, we are generating the pdf ...</span>
        <b-button variant="secondary" size="sm" class="float-right"
          @click="$root.$emit('bv::hide::modal', 'save-configuration')">
          Cancel
        </b-button>
        <b-button variant="primary" size="sm" class="float-right mr-1" @click="save()" :disabled="!confirmDisabled">
          Confirm
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import axios from "axios";

export default {
  name: "save-modal",
  data() {
    return {
      download_pdf: false,
      dealer: null,
      dealers: [
        { text: "Passoni", value: 1 },
      ],
    };
  },
  mounted() {
    let t = this;
    axios
      .get("/api/mtm-configurator/dealers")
      .then((res) => {
        this.dealers = res.data;
      })
      .catch(function (error) {
        if (error.response) {
          t.$emit('set-error', 'Cannot load dealers');
        }
      });

    let emailAddress = window.localStorage.getItem('customerEmail');

    if (emailAddress != null) {
      this.loginEmailInput = emailAddress;
    }
  },
  // Passed from parent; when present, we hide the email field.
  props: ["loginEmail", "selectedDealer", "confirmDisabled", "loggedUser", "customerReferenceLabel"],
  computed: {
    loginEmailInput: {
      get: function () {
        let storedEmail = window.localStorage.getItem('customerEmail');
        if (storedEmail != null && this.loginEmail.length == 0) return storedEmail;
        return this.loginEmail;
      },
      set: function (e) {
        this.$emit("set-login-email", e);
      },
    },
    selectedDealerInput: {
      get: function () {
        return this.selectedDealer;
      },
      set: function (e) {
        this.$emit("set-selected-dealer", e);
      }
    },
    customerReferenceLabelInput: {
      get: function () {
        return this.customerReferenceLabel;
      },
      set: function (e) {
        this.$emit("set-customer-reference-label", e);
      }
    }
  },
  methods: {

    save: function () {

      if (this.loginEmail == '' || this.loginEmail == null) {
        this.$emit('set-error', 'Please compile email')
        return false;
      }
      this.$emit("save-configuration");
    },
  },
};
</script>
